<template>
  <card-seplag :titulo="'Extrato de Contribuição Previdenciária'" cor="#00acc1" >         
        
        <div class="p-lg-12 p-col-12 dashboard" >
            <div class="summary-box summary-box-azul">
                <Card class=" card" >
                    <template slot="content">   
                        <div class="p-grid">
                            <div class="p-col-1 col-imagem">                     
                                <i class="pi pi-user summary-box-icon"></i>
                            </div>
                            <div class="p-col-md-11 p-col-sm-12">
                                <p class="summary-box-title">{{dadosPessoa.nome}}</p>
                                <p><strong>Matricula:</strong> {{dadosPessoa.matricula}}</p>
                                <p><strong>Vinculo:</strong> {{this.vinculo}}</p>
                                <p><strong>CPF:</strong> {{dadosPessoa.cpfFormatado}}</p>
                                <p><strong>RG:</strong> {{dadosPessoa.rg}}</p>
                            </div>
                        </div>
                        <img src="../../../public/assets/layout/images/tmp/graph-messages.svg" alt="sapphire" class="summary-box-graph">
                    </template>
                </Card>
            </div>
        </div>  
            <Rotulo cols="12">
                
            </Rotulo>
            <Rotulo cols="12 3" nome="Selecione o ano">
                <Dropdown  v-model="anosContribuicaoSelected" :options="anosContribuicao" optionLabel="combo" placeholder="Selecione o ano"  @input="carregarExtrato()"/>   <!--"-->
            </Rotulo>
            <div class="p-col-12"> 
                               
                <DataTable :value="extratoContribuicao" :expandedRows.sync="expandedRows" dataKey="mesAnoDescricao" > 
                    <Column :expander="true" headerStyle="width: 3em" bodyStyle="background:#e8ebef"/>
                    <Column field="mesAnoDescricao" header="Contribuições Previdenciárias" bodyStyle="background:#e8ebef; font-weight:bold"></Column>
                    <template #expansion="slotProps">
                        <DataTable :value="slotProps.data.contribuicaoPrevidenciariaRubricasLista" class="p-datatable-responsive">
                            <Column field="rubricas.codigoRubrica" header="Rúbrica" :bodyStyle="'text-align:center'"></Column>
                            <Column field="rubricas.nomeRubrica" header="Descrição"></Column>
                            <Column field="competencia" header="Competência" :bodyStyle="'text-align:center'"></Column>
                            <Column field="valor" header="Valor Patronal" :bodyStyle="'text-align:center'">
                                <template #body="slotProps">
                                    {{slotProps.data.tipoValor=='Valor Patronal'? slotProps.data.valor: "" }}
                                </template>
                            </Column>
                            <Column field="vantagem" header="Servidor" :bodyStyle="'text-align:center'">            
                                <template #body="slotProps">
                                    {{slotProps.data.tipoValor=='Servidor'? slotProps.data.valor: "" }}
                                </template>
                            </Column>
                            <template #footer>
                                <div  class="p-grid " >
                                    <div class="p-col-12 p-md-6">
                                        Total Remuneração R$ {{formatarNumero(slotProps.data.totais.totalVantagem)}}
                                    </div>
                                    <div class="p-col-12 p-md-6">
                                        Total Contribuição R$ {{formatarNumero(slotProps.data.totais.totalDesconto)}}
                                    </div>
                                </div>
                            </template>
                        </DataTable>
                    </template>
                    <template  #footer>
                        <div  class="p-grid " >
                            <div class="p-col-12 p-md-6">
                                Valores totais referente a Contri. Patronal R$ {{calcularTotalPatronal()}}
                            </div>
                            <div class="p-col-12 p-md-6">
                                Valores totais referente a Contri. Servidor R$ {{calcularTotalServidor()}}
                            </div>
                        </div>
                    </template>
                </DataTable>
            </div>
                            
            <div class="p-col-12 p-md-6  p-md-offset-5">
                <div class="p-col-12 p-md-5 p-md-offset-9" >
                    <Button label="Gerar PDF" icon="pi pi-file-pdf" @click="gerarPDF" class="p-button-primary" />
                </div>
            </div>
            <CardExibirPDF v-if="pdfElement" v-model="exibirPDF" :nomeDocumento='nomeDocumentoPDF' :tituloTela="'PDF do Extrato de Contribuição Previdenciária'" :position="'top'" :tamanhoTela="'55.em'"  :alturaTela="'55.em'" :pdfElement="pdfElement" />
  </card-seplag>    
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
// import moment from 'moment'
import Rotulo from '@/template/RotuloSeplag.vue'
import { baseApiUrl } from '@/config/global'
import CardExibirPDF from '@/template/CardExibirPDF.vue'

export default {
    name: "ContribuicaoPrevidenciaria",
    components: {CardSeplag, Rotulo, CardExibirPDF},
    data: function(){
        return {
            apiUrlRecurso: 'contribuicoesprevidenciarias',
            expandedRows : [],
            anosContribuicao: [],
            dadosPessoa: [],
            anosContribuicaoSelected: [],
            extratoContribuicao: [],
            rubricas: [],
            totais: [],
            numPensionista : null,
            matricula : null,
            vinculo : null,
            desabilitado: true,
            exibirPDF: false,
            pdfElement: null,
            nomeDocumentoPDF:'Contribuições Previdenciarias'
        }
    },
    mounted() {
        this.carregarDados();
    },
    methods: {
        expandAll() {
            this.expandedRows = this.extratoContribuicao.filter(extrato => extrato.mesAnoDescricao);
        },
        formatarNumero (numero){
            if (numero) return numero.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            return "0"
        },            
        calcularTotalPatronal(){
            let totalPatronal = 0;
            if (this.extratoContribuicao) {
                for (let extrato of this.extratoContribuicao) {
                    totalPatronal += extrato.totalPatronal;
                }
            }
            const valueString = totalPatronal.toFixed(2).replace(".", ",");
            return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            //return totalPatronal;
        },
        calcularTotalServidor(){
            let totalServidor = 0;

            if (this.extratoContribuicao) {
                for (let extrato of this.extratoContribuicao) {
                    totalServidor += extrato.totalContribuicaoServidor;
                }
            }
            const valueString = totalServidor.toFixed(2).replace(".", ",");
            return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            //return totalServidor;
        },
        formatPrice(value) {
            const val = Number(value.replace(",", "."));
            if (!val) return '0,00';
            const valueString = val.toFixed(2).replace(".", ",");
            return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        async carregarDados(){
            this.matricula  = await this.$store.getters.getMatricula
            this.vinculo = await this.$store.getters.getVinculo

            var usuario = this.$store.getters.getUser
            var identificacao = usuario.contaAcesso.identificacao
            this.numPensionista = identificacao ? usuario.dadosUsuariosCustomizados.pensionista.numeroPensionista : null
            this.dadosPessoa = {
                matricula:this.matricula,
                vinculo:this.vinculo,
                cpf:usuario.dadosUsuariosCustomizados.pessoa.documentosPessoais.cpf,
                rg: usuario.dadosUsuariosCustomizados.pessoa.documentosPessoais.rg,
                nome:usuario.dadosUsuariosCustomizados.pessoa.nome,
                cpfFormatado: usuario.dadosUsuariosCustomizados.pessoa.documentosPessoais.cpfFormatado
            }

            var v_anosContribuicao  = await this.$http.get(`${baseApiUrl}/${this.apiUrlRecurso}/anos/${this.matricula}/${this.vinculo}`)
            if(v_anosContribuicao.status==200) {
                
                v_anosContribuicao.data.forEach(res => {
                    this.anosContribuicao.push({"combo":res})
                });
                this.anosContribuicaoSelected = {"combo": v_anosContribuicao.data[0]}
                this.carregarExtrato()
            }
        },
        async carregarExtrato(){
            var contribuicaoSelecionada = {
                matricula: this.matricula,
                vinculo: this.vinculo,
                ano: this.anosContribuicaoSelected.combo
            }

            var v_contribuicoes =  await this.$http.post(`${baseApiUrl}/${this.apiUrlRecurso}/listacontribuicoes`, JSON.stringify(contribuicaoSelecionada))
            if(v_contribuicoes.status==200) {
                this.extratoContribuicao = v_contribuicoes.data
            }
            this.expandAll()
        },
        gerarPDF(){
            let dadosPDF = {
                "matricula": this.$store.getters.getMatricula,
                "vinculo": this.$store.getters.getVinculo,
                "ano": this.anosContribuicaoSelected.combo
            }
            this.$http.post(`${baseApiUrl}/contribuicoesprevidenciarias/pdf`,JSON.stringify(dadosPDF)).then(res => {
                this.pdfElement = res.data.dadosRelatorioBase64
                this.nomeDocumentoPDF = res.data.nomeArquivo
                this.exibirPDF = true
            })

        }
    }
}
</script>

<style>
    .dashboard .dashboard-grid {
        margin-left: 0;
        margin-right: 0;
        margin-top: 0;
        padding: 0;
    }
    .dashboard .card {
        height: 100%;
        margin-bottom: 0;
    }
    .dashboard .summary-box {
        position: relative;
    }
    .dashboard .summary-box .card {
        min-height: 100px;
    }
    .dashboard .summary-box .summary-box-title {
        font-size: 2em;
        margin: 0;
        color: #ffffff;
    }
    .dashboard .summary-box p {
        margin: 0.25em 0;
        color: #ffffff;
    }
    .col-imagem{
        display: inline;
    }
    .dashboard .summary-box .summary-box-icon {
        font-size: 8em;
        color: #ffffff;
    }
    .dashboard .summary-box .summary-box-graph {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    .dashboard .summary-box.summary-box-azul .card {
        border-top: 4px solid #0097a7;
        background-color: #00bcd4;
    }
    .dashboard .summary-box.summary-box-azul .ico {
        color: #0097a7;
    }

    .btnMTPrev{
        padding-top: 1.5rem;
    }

    @media screen and (max-width: 1600px) {
        
        .dashboard .summary-box .summary-box-icon {
            font-size: 6em;
            margin-top: 27px;
        } 
        .col-imagem{
            display: none;
        }
    }
    
    @media screen and (max-width: 780px) {
        body .p-component{
            font-size: 12px;
        }
        .p-datatable-responsive .p-datatable-thead > tr > th,
        .p-datatable-responsive .p-datatable-tfoot > tr > td {
            display: none !important;
        }

        .btnMTPrev{
            padding-top: 0rem;
        }
        .p-datatable-responsive .p-datatable-tbody > tr > td {
            text-align: left;
            display: block;
            border: 0 none;
            width: 100% !important;
            float: left;
            clear: left;
        }

        .p-datatable-responsive .p-datatable-tbody > tr > td .p-column-title {
            padding: .4em;
            min-width: 30%;
            display: inline-block;
            margin: -.4em 1em -.4em -.4em;
            font-weight: bold;
        }

        body .p-datatable .p-datatable-header {
            border-bottom: 1px solid #c8c8c8;
        }
    }
    
</style>